<template>
  <div>
    <div class="header">
      <div>
        <h4 class="title">
          {{ title }}
        </h4>
        <h6 class="sub-title" v-if="subTitle">
          {{ subTitle }}
        </h6>
      </div>
    </div>
    <router-view
      @sub-title="
        setSubTitle
      "
      @navigator="
        setNavigator
      "
    />
  </div>
</template>

<script>
export default {
  data () {
    return {
      title     : 'โครงการ Non SC',
      subTitle  : null
    }
  },
  computed: {
    breadcrumb() {
      return []
    }
  },
  methods: {
    setSubTitle(data) {
      this.subTitle = data
    },
    setNavigator(data) {
      // TODO: Set Breadcrumb
    }
  }
}
</script>

<style lang="css" scoped>

.header {
  border-bottom: 1px solid #efefef;
}

.header .title {
  margin: 0;
}

.header .sub-title {
  margin: 0;
  margin-top: .25rem;
}

</style>



// WEBPACK FOOTER //
// src/features/nonsc/pages/project/NonScProject.vue